import LocationService from "external-services/location-service/index";
import ObjectCopyService from "external-services/object-copy-service/index";
const template = require('./booking.html');
const verge = require('verge');
import {debounce} from 'lodash-es';
import {TIMELINE_SCROLL_CHANGED} from "app/actions/view.actions";
import GeneralSettingsService from "external-services/general-settings-service/generalSettings.service";
import BookingUpdateService from "external-services/booking-update-service/index";
import ScheduleLookupService from 'external-services/schedule-lookup-service/scheduleLookup.service';
import PouchActions, {PouchDocType} from "app/actions/pouch.actions";
import PouchSyncService, {quickEditProps} from "external-services/pouch-sync-service/index";
import BookingLookupService from "external-services/booking-lookup-service";
import TableUtilsService from "external-services/table-utils-service";
import TablesLookupService from "external-services/tables-lookup-service/tablesLookup.service";
import PaymentService from "external-services/diary-payment-service";

const NS = 'Booking'; // jshint ignore:line

const isAndroidOrIOS = LocationService.isIOS() || LocationService.isAndroid();

export default function Booking(  // as booking
  $log, $rootScope, $timeout, $filter, $document, unregister, tablesService, $mdToast,
  BookingType
) {
  "ngInject";

  return {
    restrict: 'E',
    replace: true,
    scope: {
      info: '<',
      showTables: '<',
      disabled: '<',
      fulldate: '<',
      disableStatusChange: '<',
      displayTableId: '<',
      displayBookingRef: '<',
      quickEdit: '<',
      schedule: '<',
      isCompact: '<',
      hasExtraPadding: '<',
      showMinimal: '<', // only meaningful when isOptimised is true
      isOptimised: '<' // may be true for tablets when hundreds of bookings exist to help with performance on timeline
    },
    template,
    controllerAs: 'vm',
    link,
    controller: function () { }
  };

  function link(scope, element) {
    const vm = scope.vm;
    vm.BookingType = BookingType;

    scope.isSaving = false;
    let orgBooking = ObjectCopyService.angularSafeCopy(scope.info);
    //-- define public properties
    vm.one = 1;
    vm.fullName = '';
    vm.defaultDuration = 0;
    vm.enableEndBookingTime = false;
    vm.isAndroidOrIOS = isAndroidOrIOS;

    //-- define public methods
    vm.editBooking = editBooking;
    vm.changeStatus = changeStatus;
    vm.editPeople = editPeople;
    vm.editStatus = editStatus;

    let timelineReg;
    if (scope.isOptimised) {
      vm.showMinimalByViewport = true;
      vm.showMinimalByScope = false;
    }

    //-- listen
    const listeners = [];

    listeners.push(scope.$watch('info', init));
    listeners.push(scope.$watch('info.tablesAvaiable', init));
    listeners.push(scope.$watch('info.paymentSummary', init));

    listeners.push(
      PouchActions.handlePouchSyncedDoctype(PouchDocType.booking, (evt, ids) => handleSingleBookingSync(ids))
    );


    listeners.push(scope.$on('$destroy', () => {
      unregister(listeners);
      if (timelineReg) {
        timelineReg();
      }
    }));

    if (scope.isOptimised) {
      listeners.push(scope.$watch('showMinimal',() => {
        if (scope.showMinimal) {
          vm.showMinimalByScope = true; // forces minimal view
        } else {
          vm.showMinimalByViewport = true; // reset this value so we can show minimal until scrolled to again
          vm.showMinimalByScope = false; // remove the forced minimal view so the scroll/viewport functionality can take over again
          setTimelineScrollHandler();
        }
      }));
    }

    /**
     * When a pouch synchronises a single booking, we check to see if the id matches and update the booking
     * @param updatedBookingIds
     */
    async function handleSingleBookingSync(updatedBookingIds) {
      const isSingleBookingSyncMatch = updatedBookingIds.length === 1 && updatedBookingIds[0] === scope.info._id;
      if (isSingleBookingSyncMatch) {
        const originalBooking = scope.info;

        let newBooking;
        try {
          newBooking = await BookingLookupService.getById(updatedBookingIds[0], vm.filterDate);
        } catch (err) {
          console.warn(NS, `error retrieving booking by id "${updatedBookingIds[0]}".`);
          return;
        }

        const containsOnlyQuickChanges = PouchSyncService.containsOnlyQuickChanges(originalBooking, newBooking);

        /**
         * The reason we only update these 2 properties (and deliberately mutate the object), instead of replacing the
         * whole object, is because the dragged booking has a reference to the same object and won't update with it unless
         * it is mutated. This is a bit ugly, but because the dragged booking is not rendered until it is interacted with
         * we can't update it with `PouchActions.handlePouchSyncedDoctype` in real time.
         */
        if (containsOnlyQuickChanges) {
          quickEditProps.forEach(propName => {
            scope.info[propName]  = newBooking[propName];
          });
          scope.info._rev = newBooking._rev; // needs rev to avoid conflicts
          TableUtilsService.addBookingRelatedDataToTables(scope.info);
        }
        init();
      }
    }

    function showMinimalIfInView() {
      if (vm.showMinimalByViewport) {
        const isInView = verge.inViewport(element[0]);
        vm.showMinimalByViewport = !isInView;

        if (isInView && timelineReg) {
          timelineReg();
        }
      }
    }

    function setTimelineScrollHandler() {
      showMinimalIfInView();
      if (timelineReg) {
        timelineReg();
      }
      timelineReg = $rootScope.$on(TIMELINE_SCROLL_CHANGED, debounce(showMinimalIfInView, 500));
    }

    function init() {

      if (scope.isOptimised) {
        setTimeout(() => {
          setTimelineScrollHandler();
        }, 500);
      }

      orgBooking = ObjectCopyService.angularSafeCopy(scope.info);

      const firstName = orgBooking.firstName ? orgBooking.firstName : '';
      const lastName = orgBooking.lastName ? orgBooking.lastName : '';
      vm.fullName = `${firstName} ${lastName}`;
      scope.showTableAvailable = false;
      // let totalCapacity = 0;
      getGeneralSettings();

      if (scope.info) {

        if (scope.schedule) {
          // Get the default duration for the specific service
          const activeService = scope.schedule.services.find(service => service._id === scope.info.serviceId);

          if (activeService) {
            vm.defaultDuration = ScheduleLookupService.getDefaultDuration(activeService, scope.info.people);
          }
        }

        // vm.showAsLinked = false;
        //
        // if (scope.info.tables && scope.info.tables.length > 1 && scope.displayTableId) {
        //   // var primaryTableId = $filter('orderBy')(scope.info.tables, 'name')[0]._id;
        //   let primaryTableId = scope.info.tables[0]._id;
        //   if (scope.info.primaryTableId) {
        //     primaryTableId = scope.info.primaryTableId;
        //   }
        //   if (primaryTableId !== scope.displayTableId) {
        //     vm.showAsLinked = true;
        //     for (let table of scope.info.tables) {
        //       if (table._id === primaryTableId) {
        //         scope.primaryTable = table;
        //       }
        //     }
        //   }
        // }

        const result = TablesLookupService.getPrimaryTableId(scope.info.tables, scope.info.primaryTableId, scope.displayTableId);
        scope.primaryTable = result.primaryTable;
        vm.showAsLinked = result.showAsLinked;

        // const tablesNames = [];
        // if (scope.info.tables) {
        //   for (let table of scope.info.tables) {
        //     table = tablesService.tablesLookUp[table._id];
        //     if (table) {
        //       totalCapacity += table.capacity;
        //       tablesNames.push('T' + table.name);
        //     }
        //   }
        // }
        // vm.tablesStr = tablesNames.join(',');
        vm.tablesStr = TablesLookupService.getTableListAsString(scope.info.tables, TablesLookupService.getTablesLookup());
        const totalCapacity = TablesLookupService.getTotalTableCapacity(scope.info.tables, TablesLookupService.getTablesLookup());

        vm.overCapacity = scope.info.people > totalCapacity;
        // shard over capacity
        if (scope.info.sharedOverCapacity) {
          vm.overCapacity = scope.info.sharedOverCapacity;
        }
        // table join
        if (scope.info.tableJoin && typeof scope.info.tableJoin.capacity !== "undefined") {
          vm.overCapacity = scope.info.people > scope.info.tableJoin.capacity;
        }
        // if ((!scope.info.tables || scope.info.tables.length === 0) && scope.info.tablesAvaiable) {
        //   scope.showTableAvailable = true;
        // } else {
        //   scope.showTableAvailable = false;
        // }
        scope.showTableAvailable = TablesLookupService.isTableAvailable(scope.info);
      }
    }

    function getGeneralSettings() {
      GeneralSettingsService.get().then(function (settings) {
        vm.enableEndBookingTime = settings.enableEndBookingTime;
      });
    }

    /**
     * Saves the status change to the booking
     * @param  {object} status
     */
    function changeStatus(status) { // does this even get called?
      scope.info.isSaving = true;
      scope.info.status = status;
      scope.info = BookingUpdateService.updateAfterStatusChange(scope.info, orgBooking);
      BookingUpdateService.updateFromAnywhere(scope.info, orgBooking, null, null, null, scope.schedule).then(function () {
        $timeout(function () {
          delete scope.info.isSaving;
        }, 1000);

      });
      orgBooking = ObjectCopyService.angularSafeCopy(scope.info);
    }

    /**
     * Sends a event to edit the booking
     * @param  {Event} evt the click event
     * @param  {Object} booking the booking object
     */
    function editBooking(evt) {

      if (vm.isFocused) {
        return;
      }

      const isLocked = PaymentService.conditionallyShowLockedBookingDialog(scope.info);
      if (isLocked) {
        return;
      }

      // // timeLimitInMinutes allows to control when a pending payment booking can be opened by the user. When the bookingTimeSpan is smaller than timeLimit it keeps locked
      // // DeletePendingPayment job waits for 12 minutes to trigger the booking deletion. 15 minutes gives enough time in case of job starting delays a little longer
      // const timeLimitInMinutes = 15;     // default
      // const timeLimitForPayment = (timeLimitInMinutes * 60 * 1000);     // X minutes calculated to miliseconds {Default: 660000} => 15 min
      //
      // if (scope.info.status.code == "P$") {
      //   let bookingTimeSpan = Date.now() - new Date(scope.info.bookedAt);
      //   if (scope.info.method == "online" && scope.info._rev.slice(0, 2) == "1-" && !scope.info.movedFromBookingId && bookingTimeSpan < timeLimitForPayment) {
      //
      //     $mdToast.show(
      //       $mdToast.simple()
      //         .content('Booking is locked during user payment. Please wait.')
      //         .position('bottom right')
      //         .theme('saved')
      //         .hideDelay(3000)
      //     );
      //
      //     return;
      //   }
      // }

      if (!scope.disabled) {
        const targetEl = angular.element(evt.target);
        const targetParentEl = angular.element(evt.target.parentElement);
        const isStatusSymbolTarget = targetEl.prop('tagName').toLowerCase() === 'status-symbol';
        if (!isStatusSymbolTarget && !targetEl.hasClass('status-button') && !targetEl.hasClass('status-menu') && !targetParentEl.hasClass('status-menu') && !targetEl.hasClass('people-btn') && !targetParentEl.hasClass('people-btn') && !targetEl.hasClass('duration-dragger') && !targetParentEl.hasClass('duration-dragger')) {
          // dont edit if the user click on the status
          evt.stopPropagation();

          showFocusState();
          $timeout(() => { // delay gives the focus state a chance to render before triggering overlay
            $rootScope.$broadcast('edit-booking', evt, scope.info);
          }, 100);
        }
      }
    }

    function showFocusState() {
      vm.isFocused = true;

      $timeout(() => {
        vm.isFocused = false;
      }, 2000);
    }

    function editPeople(evt) {
      showFocusState();
      $rootScope.$broadcast('edit-booking-people', evt, scope.info);
    }

    function editStatus(evt) {
      if (!scope.disabled && !scope.disableStatusChange && !scope.info.functionTracker) {
        showFocusState();
        $rootScope.$broadcast('status-edit-inline', evt, scope.info, scope.schedule);
      }
    }
  }
}
